import { AppConfigurationFeatureFlags } from './appconfiguration-feature-flags';

export abstract class AppConfigurationInterface {
  readonly name: string;
  readonly hostname: string;
  readonly development: boolean;
  readonly production: boolean;
  readonly default: any; // <-- declaring as any to avoid circular type ref and avoid major refactoring during nx/angular upgrade

  readonly applicationName: string;
  readonly sourceVersion: string;
  readonly machineName?: string;

  readonly urls: AppConfigurationUrls;

  readonly statusApp?: AppConfigurationStatusApp;
  readonly auth0: AppConfigurationAuth0;
  readonly auth: AppConfigurationAuth;
  readonly errors: AppConfigurationErrorHandling;

  readonly featureFlags: AppConfigurationFeatureFlags;
  readonly stripe: AppConfigurationStripe;

  readonly loggers: AppConfigurationLoggers;
  readonly uiSettings: AppConfigurationUiSettings;

  readonly bootstrap?: AppConfigurationBootstrap;
  readonly signalR?: AppConfigurationSignalR;
}
export interface AppConfigurationBootstrap {
  imagesToPreload?: string[];
  fontsToPreload?: string[];
  preloadTimeout: number;
}

export interface AppConfigurationElmah {
  apiKey: string;
  logId: string;
}
export interface AppConfigurationSignalR {
  hubs: { api: string; name: string; url: string }[];
}
export interface AppConfigurationAppInsights {
  connectionString: string;
}
export interface AppConfigurationUiSettings {
  list: {
    maxCountInMemory: number;
    pageSize: number;
  };
  richTextEditor?: {
    initializationTimeoutInMs: number;
  };
  file: {
    previewDialogTimeLimitInSeconds: number;
    maxCorrespondenceSizeAttachmentInMb: number;
    tusUploadLimitInMb: number; // anything larger than this will be handled by TUS protocol
    downloadTarget: string;
  };
  maxSubtypesToShowInDropdown: number;
  updatePollFrequency: number;
  showSwWarning?: boolean;
  reports: AppConfigurationReports;
  ckeditor: AppConfigurationCKEditor;
  hasNavbar: boolean;
}
export interface AppConfigurationLoggers {
  elmah: AppConfigurationElmah;
  appInsights: AppConfigurationAppInsights;
}
export interface AppConfigurationUrls {
  readonly apiRootCoManage?: string;
  readonly apiRootLpms?: string;
  readonly apiRootRms?: string;
  readonly apiRootSquirrel?: string;
  /**
   * Where a ServePort portal is served from; a portal's live address is this plus its `urlPath`. Portals live on
   * the fixed `app` host rather than the company's own subdomain, so these carry no `@` placeholder.
   */
  readonly serveportPortalRoot?: string;
  /** The shared ServePort agency portal, a themed host with no path of its own. */
  readonly serveportAgencyPortalUrl?: string;
}
export interface AppConfigurationSquirrel {
  readonly appName?: string;
  readonly keys?: {
    matterListConfiguration: string;
  };
}
export interface AppConfigurationStatusApp {
  readonly apiRootUrl: string;
  readonly cacheDurationInMinutes?: string;
  readonly code: string;
}
export interface AppConfigurationAuth0 {
  readonly authorityRoot: string;
  readonly clientId: string;
  readonly useLocalStorageCache: boolean;
}
export interface AppConfigurationAuth {
  inactivityTimeout: number; // Minutes
  inactivityWarning: number; // Minutes
}
export interface AppConfigurationErrorHandling {
  readonly numRetries: number;
}

export interface AppConfigurationStripe {
  readonly key: string;
}
export interface AppConfigurationReports {
  readonly key: string;
}
export interface AppConfigurationCKEditor {
  readonly key: string;
}
